export const RELEASES_MODEL = {
  ID: 'id',
  NAME: 'name',
  COMMIT_SHA: 'commit_sha',
  BRANCH_ID: 'branch_id',
  CONNECTED_BRANCHES: 'bound_branches',
  BODY: 'body',
  PUBLISHED_AT: 'published_at',
  PUBLISHER_AVATAR_URL: 'publisher_avatar_url',
  PUBLISHER_ID: 'publisher_id',
  PUBLISHER_NAME: 'publisher_name',
  SERVICES: 'services',
  STAGE: 'stage',
  SOURCE: 'source_type',
  REPOSITORY_NAME: 'repository_name',
  REPOSITORY_ID: 'repository_id',
  INCIDENTS_COUNT: 'incidents_count',
  SUMMARY: {
    RELEASES: 'summary.releases_count',
    REPOSITORIES: 'summary.repositories_count'
  }
};

export const RELEASES_TABLE_MODEL = {
  NAME_CELL: 'name_cell',
  COMMIT_SHA_CELL: 'commit_sha_cell',
  PUBLISHED_AT_CELL: 'published_at_cell',
  STAGE_CELL: 'stage_cell',
  CONNECTED_BRANCHES_CELL: 'connected_branches_cell',
  SERVICES_CELL: 'services_cell',
  RELEASE_DETECTION_CELL: 'release_detection_cell',
  REPOSITORY_CELL: 'repository_cell',
  INCIDENTS: 'incidents'
};
